import script from "./Viewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Viewer.vue?vue&type=script&setup=true&lang=ts"

import "./Viewer.vue?vue&type=style&index=0&id=0af3a594&lang=scss&scoped=true"
import "./Viewer.vue?vue&type=style&index=1&id=0af3a594&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af3a594"]])

export default __exports__